import { Injectable } from '@angular/core';

export interface StudentDisplay {
  username: string;
  schoolName: string;
}

/**
 * CSW-1651: in-memory (session-lifetime, not persisted) cache of a logged-
 * in student's display profile — username/schoolName for the footer.
 * Deliberately NOT backed by localStorage (see git history on
 * current-user.component.ts for why that was fragile) and deliberately
 * NOT backed by Firebase custom claims (see EducationService.
 * authenticateStudent's doc comment for why mixing display data into the
 * access-control claims object is worth avoiding).
 *
 * Populated directly at login (school-login.component.ts, from the login
 * response — no extra request needed). On a hard refresh this is empty
 * again; CurrentUserComponent falls back to GET /auth/me in that case and
 * repopulates it.
 */
@Injectable({ providedIn: 'root' })
export class StudentDisplayService {
  private current: StudentDisplay | null = null;

  get(): StudentDisplay | null {
    return this.current;
  }

  set(display: StudentDisplay): void {
    this.current = display;
  }

  clear(): void {
    this.current = null;
  }
}
